import {Route, Switch} from 'react-router-dom';

import ROUTE_PATHS from '@/consts/route/routePaths';
import {AutoDeliveryDcxProvider} from '@/containers/AutoDeliveryDcxPage/AutoDeliveryDcxContext';
import useWithLocale from '@/hooks/useWithLocale';
import autoDeliveryDcxService from '@/services/autoDeliveryDcxService';

import AutoDeliveryAsapPageSwitcher from './AutoDeliveryAsapPageSwitcher';
import AutoDeliveryPageSwitcher from './AutoDeliveryPageSwitcher';
import AutoDeliverySkipPageSwitcher from './AutoDeliverySkipPageSwitcher';

const AutoDeliveryRoutes = () => {
    const withLocale = useWithLocale();
    const isDcx = autoDeliveryDcxService.getIsAutoDeliveryDcxEnabled();

    const routes = (
        <Switch>
            <Route path={withLocale(ROUTE_PATHS.AUTO_DELIVERY_SKIP)} component={AutoDeliverySkipPageSwitcher} />
            <Route path={withLocale(ROUTE_PATHS.AUTO_DELIVERY_ASAP)} component={AutoDeliveryAsapPageSwitcher} />
            <Route path={withLocale(ROUTE_PATHS.AUTO_DELIVERY)} component={AutoDeliveryPageSwitcher} />
        </Switch>
    );

    return isDcx ? <AutoDeliveryDcxProvider>{routes}</AutoDeliveryDcxProvider> : routes;
};

export default AutoDeliveryRoutes;
